<template>
    <div>
        <v-row class="no-frame">
            <v-col class="no-frame mr-2">
                <f-date-picker
                    label           = "inc.edit.common.unitdown.start"
                    :time           = "true"
                    :rules          = "[fromRule]"
                    v-model         = "unitdata.unitDownBegin"
                    :error-messages = "error.begin"
                    @change         = "onChangeStart"
                />
            </v-col>
            <v-col class="no-frame ml-2">
                <f-date-picker
                    label           = "inc.edit.common.unitdown.end"
                    :time           = "true"
                    :rules          = "[toRule]"
                    v-model         = "unitdata.unitDownEnd"
                    :error-messages = "error.end"
                    @change         = "onChangeEnd"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import moment from "moment";
import Core from "@/modules/core/service/Core";
import FDatePicker from "@/modules/core/components/utils/FDatePicker";

export default {
    name: "IncUnitDownInterval",

    components: {
        FDatePicker
    },

    props: {
        unitdata: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    unitDownBegin: null,
                    unitDownEnd  : null,
                    unitDown     : false
                }
            }
        },

        status: {
            required: true,
            type    : Object
        },
    },

    data: () => ({
        error  : {
            begin: null,
            end  : null
        }
    }),

    methods: {
        onChangeEnd () {
            this.$emit("endchanged", this.unitdata.unitDownEnd);
        },

        onChangeStart () {
            console.log("onChangeStart", this.unitdata.unitDownBegin)
            this.$emit("startchanged", this.unitdata.unitDownBegin);
        },

        fromRule (value) {
            if (this.unitdata.unitDown && (!value || value.length === 0)) {
                this.error.begin = [this.$t("rules.required")];
                this.error.end   = [];
                return false;
            }

            if (!this.unitdata.unitDownEnd || this.unitdata.unitDownEnd.length === 0) {
                this.error.end   = [];
                this.error.begin = [];
                return true;
            }

            if (!value || value.length === 0) {
                this.error.begin = [this.$t("rules.required")];
                return false;
            }

            return this.intervallRule(Core.format.datetime.toJson(value), this.unitdata.unitDownEnd);
        },

        toRule (value) {
            if (!value || value.length === 0) {
                /*
                if (this.status.type === 'T' && this.unitdata.unitDownBegin) {
                    this.error.end = [this.$t("rules.required")];
                    if (!this.unitdata.unitDown)
                        this.error.begin = [];
                    return false;
                }

                 */

                this.error.end   = [];
                if (!this.unitdata.unitDown)
                    this.error.begin = [];

                return true;
            }

            return this.intervallRule(this.unitdata.unitDownBegin, Core.format.datetime.toJson(value));
        },

        intervallRule(beginDate, endDate) {
            if (moment(beginDate).isAfter (endDate) ) {
                this.error.end   = [this.$t("inc.edit.common.sitedown.error")];
                this.error.begin = [""];
                return false;
            } else {
                this.error.end   = [];
                this.error.begin = [];
            }

            return true;
        },
    }
}
</script>

<style scoped>

</style>